import { EventManager } from '@angular/platform-browser';

import { EventManagerPlugin } from '../types/event-manager-plugin';

export abstract class AbstractEventPlugin implements EventManagerPlugin {
  protected abstract readonly modifier: string;

  public manager!: EventManager;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  public abstract addEventListener(element: HTMLElement, eventName: string, handler: Function): Function;

  public supports(event: string): boolean {
    return event.includes(this.modifier);
  }

  protected unwrap(event: string): string {
    return event
      .split('.')
      .filter((v) => !this.modifier.includes(v))
      .join('.');
  }
}
